const gamePlatformMaintainReducers = (
  state = {
    platformList: [],
    state: false,
  },
  action
) => {
  switch (action.type) {
    case "SHOW_GAME_PLATFORM_MAINTAIN":
      return {
        platformList: action.payload.platformList,
        state: action.payload.state,
      };
    case "HIDE_GAME_PLATFORM_MAINTAIN":
      return {
        platformList: [],
        state: false,
      };
    default:
      return {
        platformList: [],
        state: false,
      };
  }
};
export default gamePlatformMaintainReducers;
